/**
 * Sizing tokens come from Slate sizing
 * https://slate.faire.team/foundations/icons/design#sizing
 */
export enum Sizing {
  SIZING_UNKNOWN = 'SIZING_UNKNOWN',
  /**
   * 16x16px
   */
  SIZING_S = 'SIZING_S',
  /**
   * 24x24px
   */
  SIZING_M = 'SIZING_M',
  /**
   * 32x32px
   */
  SIZING_L = 'SIZING_L',
}
